import { render } from "./purchaseList.vue?vue&type=template&id=08928488&scoped=true"
import script from "./purchaseList.vue?vue&type=script&lang=js"
export * from "./purchaseList.vue?vue&type=script&lang=js"

import "./purchaseList.vue?vue&type=style&index=0&id=08928488&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08928488"

export default script